export default "__VITE_ASSET__8$VSSiH4__"